import { render } from "./pendingRequests.vue?vue&type=template&id=a522576a"
import script from "./pendingRequests.vue?vue&type=script&lang=js"
export * from "./pendingRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__